import { getPersonalizedSearchPageRoute } from 'site-modules/shared/utils/personalized-search/personalized-search-utils';
import {
  SEARCH_QUERY_PARAM,
  THREAD_ID_QUERY_PARAM,
} from 'site-modules/shared/constants/personalized-search/personalized-search';
import { objectToQueryString } from 'site-modules/shared/utils/string';

export const getPersonalizedSearchLinkUrl = (query, threadId) =>
  `${getPersonalizedSearchPageRoute()}?${objectToQueryString({ [SEARCH_QUERY_PARAM]: query, [THREAD_ID_QUERY_PARAM]: threadId })}`;
